import readMessages from './readMessages';

export default (threadId, callback, errorCallback, apiUrl, headers) => readMessages({threadId}, callback, errorCallback, apiUrl, headers);
